import AppHeader from '@components/AppNavigation/AppHeader';
import HorizontalTabsPage from '@components/AppNavigation/HorizontalTabsPage';
import AdminsTable from '@components/Users/Admins/AdminsTable';
import { Box } from '@mui/material';
import ManagementKeysPage from 'pages/ManagementKeys/ManagementKeysPage';
import React, { FC, useMemo } from 'react';
import { CompanyPageTabs } from 'types/settings';
import CompanySettingsSkeleton from './CompanySettingsSkeleton';

const CompanyPage: FC = () => {
	const tabs = useMemo(
		() => [
			{ id: CompanyPageTabs.settings, component: <CompanySettingsSkeleton /> },
			{ id: CompanyPageTabs.admins, component: <AdminsTable /> },
			{ id: CompanyPageTabs.managementKeys, component: <ManagementKeysPage /> }
		],
		[]
	);
	return (
		<Box
			display="flex"
			flexGrow={1}
			data-testid="company-page"
			flexDirection="column"
		>
			<AppHeader translation="pages.company.title" />
			<HorizontalTabsPage
				tabs={tabs}
				routeName="company"
				fullRoute="settings/company"
			/>
		</Box>
	);
};

export default CompanyPage;
